"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
var tslib_1 = require("tslib");
var ui_global_styles_1 = require("@hopin-team/ui-global-styles");
var react_1 = tslib_1.__importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var styled_components_1 = require("styled-components");
var _1 = require(".");
var themeActions_1 = require("./state/themeActions");
var themeReducer_1 = require("./state/themeReducer");
var themeState_1 = require("./state/themeState");
var ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.includesGlobalStyles, includesGlobalStyles = _b === void 0 ? true : _b;
    var Provider = _1.ThemeContext.Provider;
    var _c = tslib_1.__read((0, react_1.useReducer)(themeReducer_1.themeReducer, (0, themeState_1.initialState)()), 2), state = _c[0], dispatch = _c[1];
    var setCustomTheme = function (newTheme) {
        return dispatch({ type: themeActions_1.THEME_ACTIONS.CUSTOM_THEME_SET, payload: { newTheme: newTheme } });
    };
    var setCustomFonts = function (newFonts) {
        return dispatch({ type: themeActions_1.THEME_ACTIONS.CUSTOM_FONT_SET, payload: { newFonts: newFonts } });
    };
    (0, react_1.useEffect)(function () {
        dispatch({ type: themeActions_1.THEME_ACTIONS.LOADED_SET });
    }, []);
    return (react_1.default.createElement(Provider, { value: tslib_1.__assign(tslib_1.__assign({}, state), { setCustomTheme: setCustomTheme, setCustomFonts: setCustomFonts }) },
        state.isThemeLoaded && (react_1.default.createElement(react_helmet_1.Helmet, null,
            state.fontUrls.textFontUrl && (react_1.default.createElement("link", { href: state.fontUrls.textFontUrl, rel: "stylesheet", id: "hopin-text-font" })),
            state.fontUrls.displayFontUrl && (react_1.default.createElement("link", { href: state.fontUrls.displayFontUrl, rel: "stylesheet", id: "hopin-display-font" })))),
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: state.currentTheme },
            includesGlobalStyles && react_1.default.createElement(ui_global_styles_1.GlobalStyles, null),
            children)));
};
exports.ThemeProvider = ThemeProvider;
exports.ThemeProvider.displayName = 'ThemeProvider';
//# sourceMappingURL=ThemeProvider.js.map